import PayStubChooseTemplateNew from './PayStubChooseTemplateNew'

export default PayStubChooseTemplateNew
